import { useEffect, useState } from "react";

import { ProposalEngineAccess, type ProposalEngineAccessState } from "../utils/proposal-engine-access";

const NOT_YET_KNOWN: ProposalEngineAccessState = { signedIn: false, enabled: false, authorName: null };

export function useProposalEngineAccess(): ProposalEngineAccessState {
  const [access, setAccess] = useState<ProposalEngineAccessState>(NOT_YET_KNOWN);

  useEffect(() => {
    let cancelled = false;
    void ProposalEngineAccess.current().then((current) => {
      if (!cancelled) setAccess(current);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return access;
}

export function useProposalEngineEnabled(): boolean {
  return useProposalEngineAccess().enabled;
}
